import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

// The requester is the session user and is never listed among the guests.
const createTableRequest = async (request) => {
  const response = await axios.post(
    routes.tableRequests,
    request,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};
export default createTableRequest;
